"use client";
import { layoutStyles } from "./forum-layout.styles";

import * as stylex from "@stylexjs/stylex";
import { styles } from "./forum.styles";

import type { ForumLinkRenderer } from "./forum.types";
import type { ReactNode } from "react";

export type ForumLayoutProps = Readonly<{
  layout?: "page" | "embedded";
  name: string;
  description?: string | null | undefined;
  homeHref?: string | null | undefined;
  wikiRail?: ReactNode;
  renderLink: ForumLinkRenderer;
}>;

export function ForumLayout({
  description,
  homeHref,
  wikiRail,
  renderLink,
  children,
}: Readonly<{
  description: ForumLayoutProps["description"];
  homeHref: ForumLayoutProps["homeHref"];
  wikiRail: ReactNode;
  renderLink: ForumLayoutProps["renderLink"];
  children: ReactNode;
}>) {
  const premise = description?.match(/^.*?[.!?](?=\s|$)/)?.[0] ?? description;
  const hasRail = Boolean(homeHref || wikiRail);
  return (
    <div {...stylex.props(layoutStyles.grid, hasRail && layoutStyles.withRail)}>
      <div {...stylex.props(styles.content)}>{children}</div>
      {hasRail && (
        <aside aria-label="Related pages" {...stylex.props(layoutStyles.rail)}>
          {homeHref && (
            <section>
              <h2 {...stylex.props(layoutStyles.railHeading)}>The coworld</h2>
              {premise && (
                <p {...stylex.props(layoutStyles.railDescription)}>{premise}</p>
              )}
              {renderLink({
                href: homeHref,
                ...stylex.props(styles.link),
                children: "Open the coworld's page →",
              })}
            </section>
          )}
          {wikiRail}
        </aside>
      )}
    </div>
  );
}
